import React, {useState, useRef} from 'react'
import Page from 'ui/page'
import LanguageSwitcher from 'ui/language_switcher'
import {
  Navbar,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Card,
  CardHeader,
  CardBody
} from 'reactstrap'
import parse from 'react-html-parser'
import styled from 'styled-components'
import cn from 'classnames'
import Modal from 'ui/modal'
import {useTranslation} from 'react-i18next'
import {accessibilityGradeIcons} from 'containers/list/classes'
import {scrollIntoView} from 'scroll-js'
import Features from './product_details/features'
import StartingPoint from './product_details/starting_point'

const Styles = styled.div`
`

const Highlights = ({highlights}) => {
  const {i18n} = useTranslation()
  const highlightsArray = JSON.parse(highlights)

  if (!highlightsArray || (highlightsArray && highlightsArray.length < 1) ) { return '' }

  return (
    <React.Fragment>
      <h2>{i18n.t('product_info.highlights')}</h2>
      <ul className="m- p-0" style={{listStyleType: 'none'}}>
        {highlightsArray.map((item) =>
          <li className="arrow-left">
            <i className='fas fa-chevron-right text-primary mr-1'/> {parse(item)}
          </li>
        )}
      </ul>
    </React.Fragment>
  )
}  

const ProductInfo = (props) => {
  const {title, info, duration, duration_description, languages_label, evoucher, accessibility_grade,
    pet_friendly_grade, return_policy_text, starting_point, long_description, short_description,
    highlights, includes, not_includes, must_know, featured_image, images
  } = props
  const {i18n} = useTranslation()
  const descriptionRef = useRef()
  const detailsRef = useRef()
  const returnPolicyRef = useRef()
  const locationRef = useRef()

  const Menu = () => {
    const scrollToSection = (ref) => {
      if (ref.current) {
        scrollIntoView(ref.current, document.body, { behavior: 'smooth' })
      }
    }

    return (
      <Nav
        pills
        className="font-weight-bold sticky-top bg-white"
        style={{borderBottom: '1px solid rgba(0, 0, 0, 0.125'}}
      >
        <NavItem>
          <NavLink
            href="#"
            onClick={() => scrollToSection(descriptionRef)}
            className="pl-0"
          >
            {i18n.t('product_info.description_title')}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="#"
            onClick={() => scrollToSection(detailsRef)}
          >
            {i18n.t('product_info.details_title')}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="#"
            onClick={() => scrollToSection(returnPolicyRef)}
          >
            {i18n.t('product_info.return_policy_title')}
          </NavLink>
        </NavItem>
        {starting_point &&
          <NavItem>
            <NavLink
              href="#"
              onClick={() => scrollToSection(locationRef)}
            >
              {starting_point.location_point_type == 'meeting_point' &&
                <React.Fragment>{i18n.t('product_info.meeting_point_title')}</React.Fragment>
              }

              {starting_point.location_point_type == 'hotel_pickup' &&
                <React.Fragment>{i18n.t('product_info.hotel_pickup_title')}</React.Fragment>
              }

              {starting_point.location_point_type == 'venue' &&
                <React.Fragment>{i18n.t('product_info.venue_title')}</React.Fragment>
              }
            </NavLink>
          </NavItem>
        }
      </Nav>
    )
  }

  const Description = ({long_description, short_description}) => {
    const [expanded, setExpanded] = useState(short_description && long_description ? false : true)

    return (
      <React.Fragment>
        <h2>
          {i18n.t('product_info.description_title')}
        </h2>

        {short_description &&
          <p>
            {parse(short_description)}
          </p>
        }

        {long_description &&
          <div style={{
            display: expanded ? 'block' : 'none'
          }}>
            {parse(long_description)}
          </div>
        }

        {short_description && long_description &&
          <React.Fragment>
            <hr/>

            <div onClick={() => setExpanded(!expanded)} className="text-primary font-weight-bold text-center" style={{fontSize: '0.8em', cursor: 'pointer'}}>
              {expanded ? (
                <div>
                  <i className="fa fa-arrow-up mr-2"/> {i18n.t('product_info.show_less')}
                </div>

              ) : (
                <div>
                  <i className="fa fa-arrow-down mr-2"/> {i18n.t('product_info.show_more')}
                </div>
              )}
            </div>
          </React.Fragment>

        }

      </React.Fragment>
    )
  }

  const ReturnPolicy = ({return_policy_text}) => {
    return (
      <React.Fragment>
        <h2>
          {i18n.t('product_info.return_policy_title')}
        </h2>
        <p className="policy-text">{parse(return_policy_text)}</p>
      </React.Fragment>
    )
  }

  return (
    <Styles>
      <Menu/>

      {(short_description || long_description) &&
        <div ref={descriptionRef}>
          <Row  className="mt-4 description">
            <Col>
              <Description short_description={short_description} long_description={long_description}/>
            </Col>
          </Row>
        </div>
      }

      {highlights &&
        <Row  className="mt-4 highlights">
          <Col>
            <Highlights highlights={highlights}/>
          </Col>
        </Row>
      }      

      <div ref={detailsRef}>
        <Row className='my-4 details'>
          <Col>
            <Features {...props}/>
          </Col>
        </Row>
      </div>

      {return_policy_text &&
        <div ref={returnPolicyRef}>
          <Row className='mt-5'>
            <Col>
              <ReturnPolicy return_policy_text={return_policy_text}/>
            </Col>
          </Row>
        </div>
      }

      {starting_point &&
        <div ref={locationRef}>
          <Row innerRef={locationRef} className='my-4'>
            <Col>
              {(starting_point.name || starting_point.address || starting_point.instructions) &&
                <StartingPoint {...starting_point}/>
              }
            </Col>
          </Row>
        </div>
      }
    </Styles>
  )
}

export default ProductInfo
